<template>
  <div class="top-menu">
    <div class="left">
      <div class="logo animate__animated animate__backInLeft">
        <div class="logo-img"></div>
      </div>
      <div class="menu animate__animated animate__backInRight">
        <ul>
          <li>
            <label class="title" @click="goHome">首页</label>
          </li>
          <!-- 基金研究 -->
          <li v-for="(item, index) in menuList" :key="index">
            <a-dropdown>
              <label class="title">
                {{item.title}} &nbsp;<a-icon type="down" />
              </label>
              <a-menu slot="overlay" @click="fundClick">
                <a-menu-item v-for="ele in item.childList" :key="ele.code">
                  {{ele.name}}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </li>
          <!-- 帮助中心 -->
          <li>
            <label class="title" @click="goHelp">
              帮助中心
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="!isLogin" class="right animate__animated animate__backInDown">
      <a-button type="primary" class="right-btn" @click="loginFun">
        登录
      </a-button>
    </div>
  </div>
</template>
<script>
/* 顶部导航 */
export default {
  name: 'TopMenu',
  components: {
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data() {
    return {
      menuList: [
        { 
          title: '基金研究', 
          childList: [ 
            { name: '基金筛选', code: 'k1' },
            { name: '产品对比', code: 'k2' }
          ] 
        },
        { 
          title: '策略主题', 
          childList: [ 
            { name: '策略主题', code: 'k3' },
            { name: '新发基金', code: 'k4' }
          ] 
        },
        { 
          title: '基金经理', 
          childList: [ 
            { name: '基金经理筛选', code: 'k5' },
            { name: '基金经理对比', code: 'k6' }
          ] 
        },
        { 
          title: '基金公司', 
          childList: [ 
            { name: '基金公司筛选', code: 'k7' },
            { name: '基金公司对比', code: 'k8' }
          ] 
        },
        { 
          title: '研究工具', 
          childList: [ 
            { name: '快速回测', code: 'k9' },
            { name: '标的穿透', code: 'k10' },
            { name: '尽调管理', code: 'k11' },
          ] 
        },
        { 
          title: '产品池', 
          childList: [ 
            { name: '产品池', code: 'k12' },
            { name: '产品池管理', code: 'k13' },
          ] 
        }
      ],
      urlMap: {
        k1: '/front-layout/front-frs/#/frontFre/freProduct/productList',
        k2: '/front-layout/front-frs/#/frontFre/freComparison/comparisonOfFunds',
        k3: '/front-layout/front-frs/#/frontFre/freStrategyFund/strategyFund',
        k4: '/front-layout/front-frs/#/frontFre/freNewFund/newFundList',
        k5: '/front-layout/front-frs/#/frontFre/freManager/managerList',
        k6: '/front-layout/front-frs/#/frontFre/freComparison/comparisonOfManagers',
        k7: '/front-layout/front-frs/#/frontFre/freCompany/companyList',
        k8: '/front-layout/front-frs/#/frontFre/freComparison/ComparisonOfCompanies',
        k9: '/front-layout/front-frs/#/frontFre/FrePool/ImageAnalysis',
        k10: '/front-layout/front-frs/#/frontFre/fundResearch/productUnderlying',
        k11: '/front-layout/front-frs/#/frontFre/fundResearch/fundDueDiligence',
        k12: '/front-layout/front-frs/#/frontFre/FrePool/ProductPool',
        k13: '/front-layout/front-frs/#/frontFre/FrePool/ProductPoolManage'
      }
    };
  },
  computed: {},
  created() {
  },
  methods: {
    goHome() {
      window.location.href = window.CONFIG_OBJ.homeUrl;
    },
    goHelp() {
      window.location.href = window.CONFIG_OBJ.helpUrl;
    },
    loginFun() {
      // const url = 'http://localhost:8008'; //
      // const url = window.location.origin;
      // window.location.href = url + '/front-layout/login'
      window.location.href = window.CONFIG_OBJ.fundUrl;
    },
    // 跳转方法
    fundClick(obj) {
      console.log('key--', obj);
      // const url = 'http://localhost:8008'; //
      // const url = window.location.origin;
      const url = window.CONFIG_OBJ.baseUrl
      window.location.href = url + this.urlMap[obj.key];
      // if (this.isLogin) {
      //   window.location.href = url + this.urlMap[obj.key];
      // } else {
      //   window.location.href = window.CONFIG_OBJ.fundUrl;
      // }
    }
  }
};
</script>

<style lang='less' scoped>
.top-menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 4% 0 4%;
  width: 100%;
  height: 72px;
  background: #fff;
  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    .logo {
      .logo-img {
        display: inline-block;
        width: 228px;
        height: 32px;
        background: url(~@/assets/logo.png);
        background-size: 100% 100%;
        vertical-align: -3px;
      }
      label {
        margin-left: 10px;
        color: #333333;
        font-size: 16px;
      }
    }
    .menu {
      ul {
        display: flex;
        flex-direction: row;
        padding: 10px 0 0 10px;
        li {
          margin: 0 18px;
          .title {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          .title:hover {
            color: #4686F2;
            cursor: pointer;
          }
        }
      }
    }
  }
  .right {
    padding-top: 18px;
    .right-btn {
      width: 96px;
      height: 36px;
    }
  }
}
</style>